import React from "react"
import { Container, Row, Col, Card } from "reactstrap"

const PrivacyPolicy = () => {
    return (
        <Container className="mt-5 mb-5">
            <Row className="justify-content-center">
                <Col lg="10">
                    <Card className="p-4" style={{ borderRadius: 12 }}>
                        <h2 className="mb-2">Política de Privacidade – AirApp</h2>
                        <p className="text-muted mb-4">Última atualização: Uberlândia, 01 de Janeiro de 2026</p>

                        <p>
                            Bem-vindo ao AirApp. A sua privacidade é uma prioridade para nós. Esta Política de Privacidade
                            explica como coletamos, usamos, compartilhamos e protegemos suas informações ao utilizar nosso
                            aplicativo e serviços relacionados ao mercado de seguros.
                        </p>

                        <h5 className="mt-4">1. Quem Somos</h5>
                        <p>
                            O AirApp é operado por <strong>WOW NEGOCIOS - 50.065.472/0001-09</strong>, com sede em Uberlândia/MG.
                            Somos os controladores dos dados coletados através desta plataforma.
                        </p>

                        <h5 className="mt-4">2. Informações que Coletamos</h5>
                        <p>Para oferecer uma experiência de alta performance (perfil “Influente Executador”), coletamos:</p>
                        <ul>
                            <li>
                                <strong>Dados de Cadastro:</strong> nome, e-mail, telefone, CPF e dados profissionais.
                            </li>
                            <li>
                                <strong>Dados de Vendas e Seguros:</strong> informações inseridas por você sobre apólices,
                                renovações e leads (similar ao Agendor CRM).
                            </li>
                            <li>
                                <strong>Dados de Uso:</strong> endereço IP, tipo de dispositivo, identificadores de publicidade e
                                logs de erros.
                            </li>
                            <li>
                                <strong>Permissões de Dispositivo:</strong> podemos solicitar acesso à sua agenda de contatos,
                                câmera (para documentos) e localização (para gestão de visitas), sempre com seu consentimento
                                explícito.
                            </li>
                        </ul>

                        <h5 className="mt-4">3. Finalidade do Tratamento</h5>
                        <p>Utilizamos seus dados para:</p>
                        <ul>
                            <li>
                                <strong>Execução do Serviço:</strong> gerenciar sua carteira de seguros e atividades de vendas.
                            </li>
                            <li>
                                <strong>Comunicação:</strong> enviar atualizações sobre o app e conteúdos de mentoria.
                            </li>
                            <li>
                                <strong>Segurança:</strong> prevenir fraudes e acessos não autorizados.
                            </li>
                            <li>
                                <strong>Melhoria Contínua:</strong> analisar o comportamento de uso para otimizar o fluxo de
                                trabalho.
                            </li>
                        </ul>

                        <h5 className="mt-4">4. Compartilhamento de Dados</h5>
                        <p>Não vendemos seus dados. O compartilhamento ocorre apenas com:</p>
                        <ul>
                            <li>
                                <strong>Provedores de Infraestrutura:</strong> servidores de hospedagem e ferramentas de análise.
                            </li>
                            <li>
                                <strong>Parceiros de Negócio:</strong> seguradoras (apenas se integrado por você para cotações).
                            </li>
                            <li>
                                <strong>Obrigação Legal:</strong> quando exigido por autoridades governamentais ou regulatórias.
                            </li>
                        </ul>

                        <h5 className="mt-4">5. Seus Direitos (LGPD)</h5>
                        <p>Você possui controle total sobre seus dados. A qualquer momento, pode solicitar:</p>
                        <ul>
                            <li>Acesso aos dados coletados.</li>
                            <li>Correção de dados incompletos ou inexatos.</li>
                            <li>Exclusão definitiva da conta e de todos os dados associados (exigência Apple/Google).</li>
                            <li>Revogação de consentimentos anteriores.</li>
                        </ul>

                        <h5 className="mt-4">6. Segurança</h5>
                        <p>
                            Adotamos medidas técnicas e administrativas avançadas para proteger seus dados, incluindo
                            criptografia de ponta a ponta e protocolos de acesso restrito, garantindo que suas informações de
                            negócio estejam seguras.
                        </p>

                        <h5 className="mt-4">7. Retenção de Dados</h5>
                        <p>
                            Mantemos suas informações apenas pelo tempo necessário para cumprir as finalidades descritas ou
                            conforme exigido por lei. Caso decida encerrar sua conta, os dados serão excluídos ou anonimizados.
                        </p>

                        <h5 className="mt-4">8. Contato</h5>
                        <p className="mb-0">
                            Para dúvidas ou exercer seus direitos, entre em contato com nosso Encarregado de Dados (DPO):
                        </p>
                        <ul className="mb-0">
                            <li>
                                <strong>E-mail:</strong> contato@airapp.com.br
                            </li>
                            <li>
                                <strong>Celular:</strong> 34 991986265
                            </li>
                            <li>
                                <strong>Endereço:</strong> Uberlândia, MG.
                            </li>
                        </ul>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default PrivacyPolicy